<div class="container-band">
  @if (assemblyOrder) {
    <div class="container-fluid col container-border" [ngClass]="getOrderStatus(assemblyOrder.statusId)"
      [style.height.px]="maxHeight">
      @if (assemblyOrder.statusId == _assemblyOrderEnum.Cancelada && !showOrderDetails) {
        <div [ngClass]="getDiagonalStrip(assemblyOrder.statusId)">Cancelada</div>
      }
      @if (assemblyOrder.statusId == _assemblyOrderEnum.Reprogramada && !showOrderDetails) {
        <div [ngClass]="getDiagonalStrip(assemblyOrder.statusId)">{{assemblyOrder.statusObservation}}</div>
      }
      @if (assemblyOrder.statusId == _assemblyOrderEnum.Pospuesta && !showOrderDetails) {
        <div [ngClass]="getDiagonalStrip(assemblyOrder.statusId)">{{assemblyOrder.statusObservation}}</div>
      }
      <div class="comp-header">
        <div class="row">
          <div class="col first-rows icon-container" [ngClass]="getPoolStatus(assemblyOrder.poolShell.statusId)">
            <span class="center">
              {{ assemblyOrder.productName }}
              {{
              assemblyOrder.productQuality == "Primera"
              ? ""
              : assemblyOrder.productQuality + " - "
              }}
            {{ assemblyOrder.warrantyNumber }}</span>
            <div class="orient">
              @if (assemblyOrder.poolShell.statusId == 1) {
                <mat-icon
                style="transform: scaleX(-1)">build_circle</mat-icon>
              }
              @if (assemblyOrder.poolShell.statusId == 2) {
                <mat-icon>watch_later</mat-icon>
              }
              @if (assemblyOrder.poolShell.statusId == 3) {
                <mat-icon>check_circle</mat-icon>
              }
              @if (assemblyOrder.poolShell.statusId == 4) {
                <mat-icon class="warn">error</mat-icon>
              }
            </div>
            <div class="orient-2">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_6593_1970" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="11"
                  height="11">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.5 11C8.53757 11 11 8.53757 11 5.5C11 4.10276 10.479 2.82721 9.62062 1.85704C9.64049 1.83553 9.66028 1.81414 9.68 1.79287V1.32H9.25245C9.22597 1.34845 9.1994 1.37709 9.17273 1.40591C8.19896 0.531769 6.91158 0 5.5 0C4.08842 0 2.80104 0.531773 1.82726 1.40592C1.80059 1.3771 1.77401 1.34845 1.74754 1.32H1.32V1.79288C1.33971 1.81415 1.3595 1.83554 1.37937 1.85705C0.521017 2.82722 0 4.10277 0 5.5C0 8.53757 2.46243 11 5.5 11ZM1.37937 1.85705C1.53381 2.02429 1.69269 2.19862 1.85447 2.37615C2.27026 2.83241 2.70528 3.30977 3.13373 3.7419C3.26211 3.87149 3.39262 3.9989 3.52521 4.1241C3.53621 3.84933 3.57065 3.58739 3.63621 3.34614C3.62864 3.33856 3.62108 3.33105 3.61352 3.32354C3.60266 3.31276 3.59179 3.30197 3.58089 3.29095C3.17289 2.87953 2.75286 2.41867 2.34361 1.96963C2.16894 1.77799 1.99623 1.58849 1.82726 1.40592C1.66946 1.54757 1.51989 1.69822 1.37937 1.85705ZM9.62062 1.85704C9.4801 1.69821 9.33053 1.54756 9.17273 1.40591C9.00386 1.58839 8.83124 1.77778 8.65666 1.96932C8.24732 2.41844 7.82718 2.87941 7.41911 3.29093C7.40815 3.30202 7.39722 3.31287 7.38629 3.32373C7.37879 3.33117 7.37129 3.33862 7.36379 3.34614C7.42935 3.58739 7.46379 3.84933 7.47479 4.1241C7.60738 3.9989 7.73789 3.87148 7.86627 3.74188C8.29471 3.30976 8.72974 2.83239 9.14554 2.37613C9.30732 2.1986 9.46619 2.02427 9.62062 1.85704ZM4.20271 2.85972C4.45693 2.50762 4.8501 2.29422 5.5 2.29422C6.14992 2.29422 6.54307 2.50762 6.79729 2.85974C7.05152 3.21184 7.16287 3.72594 7.16287 4.32571C7.16287 4.90549 6.94287 5.64205 6.6149 6.21678C6.28693 6.79157 5.85344 7.17878 5.5 7.17878C5.14656 7.17878 4.71307 6.79157 4.3851 6.21678C4.05713 5.64203 3.83713 4.90545 3.83713 4.32565C3.83713 3.72589 3.94848 3.21182 4.20271 2.85972ZM6.41679 3.81825C6.41679 3.30946 6.00446 2.89363 5.5 2.89363C4.99554 2.89363 4.58321 3.30946 4.58321 3.81825C4.58321 4.327 4.99554 4.74287 5.5 4.74287C6.00446 4.74287 6.41679 4.327 6.41679 3.81825ZM5.26976 3.25792C5.34278 3.22759 5.42103 3.21214 5.5 3.21246C5.57897 3.21214 5.65722 3.22759 5.73024 3.25792C5.80326 3.28825 5.8696 3.33286 5.92544 3.38917C5.98128 3.44549 6.02551 3.5124 6.05558 3.58604C6.08565 3.65968 6.10097 3.7386 6.10066 3.81825C6.10097 3.89789 6.08565 3.9768 6.05557 4.05044C6.0255 4.12408 5.98127 4.19099 5.92543 4.24731C5.86959 4.30362 5.80325 4.34823 5.73023 4.37856C5.65721 4.40889 5.57897 4.42435 5.5 4.42403C5.42103 4.42435 5.34278 4.40889 5.26977 4.37856C5.19675 4.34823 5.13041 4.30362 5.07457 4.24731C5.01873 4.19099 4.9745 4.12408 4.94443 4.05044C4.91435 3.9768 4.89903 3.89789 4.89934 3.81825C4.89903 3.7386 4.91435 3.65968 4.94442 3.58604C4.97449 3.5124 5.01872 3.44549 5.07456 3.38917C5.1304 3.33286 5.19674 3.28825 5.26976 3.25792ZM5.7146 6.2035C5.65768 6.1461 5.58049 6.11385 5.5 6.11385C5.41951 6.11385 5.34232 6.1461 5.2854 6.2035C5.22849 6.2609 5.19651 6.33876 5.19651 6.41994C5.19651 6.46013 5.20436 6.49993 5.21961 6.53707C5.23486 6.5742 5.25722 6.60794 5.2854 6.63637C5.31358 6.66479 5.34704 6.68734 5.38386 6.70272C5.42068 6.7181 5.46014 6.72602 5.5 6.72602C5.58049 6.72602 5.65768 6.69377 5.7146 6.63637C5.77151 6.57897 5.80349 6.50111 5.80349 6.41994C5.80349 6.33876 5.77151 6.2609 5.7146 6.2035ZM5.533 8.03999C5.39459 7.92758 5.09742 7.64431 5.126 7.42138V7.42139C5.24604 7.47044 5.37082 7.49761 5.5 7.49761C5.62754 7.49761 5.75084 7.47113 5.86946 7.42327C6.68117 7.74064 6.66295 8.49583 6.65927 8.57403C6.63306 9.12617 6.11855 9.69623 5.49445 9.67965C4.45781 9.6521 4.33144 8.89041 4.32978 8.59956C4.32957 8.5874 4.32947 8.57545 4.32937 8.5635C4.32885 8.50268 4.32834 8.44191 4.31458 8.35441C4.28734 8.2931 4.24757 8.24502 4.21172 8.20169C4.14785 8.12447 4.09645 8.06233 4.15058 7.9672C4.25295 7.87446 4.37406 7.96117 4.47559 8.03388C4.49227 8.04582 4.50841 8.05738 4.52386 8.06771C4.66767 8.16966 4.76976 8.32136 4.81977 8.48308C4.88912 8.70755 4.95247 8.86285 5.13702 8.94964C5.40755 9.08266 5.81986 8.91156 5.84158 8.54915C5.83621 8.34876 5.77303 8.23494 5.533 8.03999Z"
                    fill="#A8A8A8" />
                  </mask>
                  <g mask="url(#mask0_6593_1970)">
                    <circle cx="5.5" cy="5.5" r="5.5" [class.delivered]="assemblyOrder.poolShell.inTransit" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col first-rows" [ngClass]="assemblyOrder.productColorName.toLocaleLowerCase()">
              <span class="center">{{ assemblyOrder.productColorName }} </span>
            </div>
          </div>
          <div class="row">
            <div class="col first-rows">
              <span class="center">{{ assemblyOrder.clientCity }} </span>
            </div>
          </div>
          <div class="row">
            <div class="col first-rows">
              <span class="center">
                {{ assemblyOrder.clientName }} - {{ assemblyOrder.pointOfSale }}
              </span>
            </div>
          </div>
        </div>
        <div class="assemblyTaskList">
          <ul>
            @for (task of assemblyOrder.assemblyTasks; track task) {
              <li>
                <div class="row item">
                  <div class="col-5 border text-left">
                    <span style="padding: 0%">{{ task.alias }}</span>
                  </div>
                  <div class="col-7 border icon-container" [ngClass]="getProdStatus(task.statusId)">
                    <span class="center">{{ task.description }}</span>
                    <div class="orient">
                      @if (task.statusId == 1 || task.statusId == 2) {
                        <mat-icon
                        style="transform: scaleX(-0.9) scaleY(0.9)">build_circle</mat-icon>
                      }
                      @if (task.statusId == 3) {
                        <mat-icon style="transform: scale(0.9)">check_circle</mat-icon>
                      }
                      @if (task.statusId == 4) {
                        <mat-icon class="warn">error</mat-icon>
                      }
                    </div>
                  </div>
                </div>
              </li>
            }
          </ul>
          <div class="spacer"></div>
          <!-- spacer to complete available space -->
        </div>
        @if (assemblyOrder.rescheduledObservation) {
          <div class="comp-footer row">
            <div class="border rescheduledObservations">
              <span class="center">{{ assemblyOrder.rescheduledObservation }}</span>
            </div>
          </div>
        }
        @if (assemblyOrder.reportInfo) {
          <div class="comp-footer row">
            <div class="border rescheduledObservations">
              <span class="center">{{ assemblyOrder.reportInfo }}</span>
            </div>
          </div>
        }
        <div class="comp-footer row">
          <div class="border observations icon-container">
            <span class="center">{{ assemblyOrder.observations }}</span>
            <div class="align-self-center" style="margin-right: 3px">
              <mat-icon [ngClass]="{ ready: isOrderFinished }">check_circle</mat-icon>
            </div>
          </div>
        </div>
      </div>
    }
    @if (assemblyOrder.statusId == _assemblyOrderEnum.Cancelada) {
      <div
        class="order-cancelled-ovelay h-100 p-0"
      ></div>
    }
  </div>